import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		logo: "",
		nav: [],
	},
	getters: {
		LOGO: state => state.logo,
		NAV:  state => state.nav,
	},
	mutations: {
		SET_LOGO(state,val){
            state.logo = val;
        },
		SET_NAV(state,val){
			state.nav = val;
		}
	},
	actions: {
		setLogo({ commit }, val) {
			commit("SET_LOGO", val);
		},
		setNav({ commit }, val) {
			commit("SET_NAV", val);
		}
	},
	modules: {
	}
})
